import { PageViewEventLogger } from '@repo/tracking-service';

import { SurveyCompletedContainer } from '@/components/survey/completed/SurveyCompletedContainer';

function SurveyCompletedPage() {
  return (
    <PageViewEventLogger pageName={'survey_completed'}>
      <SurveyCompletedContainer />
    </PageViewEventLogger>
  );
}

export default SurveyCompletedPage;
